import { create } from "zustand";

// 認証状態管理(Zustand)
// access_token は sessionStorage に保存(タブ閉じ消去・XSS 対策で localStorage 不使用)

const STORAGE_KEY = "tsubamecard_web_session";

interface SessionPersisted {
  accessToken: string;
  expiresAt: number; // epoch milliseconds
  email?: string;
}

function loadSession(): SessionPersisted | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SessionPersisted;
    if (Date.now() >= parsed.expiresAt) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function saveSession(session: SessionPersisted): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

function clearSession(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

interface AuthState {
  accessToken: string | null;
  expiresAt: number | null;
  email: string | null;
  setSession: (token: string, expiresAt: number, email?: string) => void;
  signOut: () => void;
}

const initial = loadSession();

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: initial?.accessToken ?? null,
  expiresAt: initial?.expiresAt ?? null,
  email: initial?.email ?? null,

  setSession: (token, expiresAt, email) => {
    saveSession({ accessToken: token, expiresAt, email });
    set({ accessToken: token, expiresAt, email: email ?? null });
  },

  signOut: () => {
    clearSession();
    set({ accessToken: null, expiresAt: null, email: null });
  },
}));
